
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../../components/base/Card';
import { Button } from '../../../components/base/Button';
import { featuredEvent } from '../../../mocks/events';

export const FeaturedEvent: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Featured Event</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Don't miss our upcoming signature event celebrating Persian culture and community
          </p>
        </div>

        <Card className="overflow-hidden max-w-4xl mx-auto">
          <div className="md:flex">
            <div className="md:w-1/2">
              <img
                src={featuredEvent.image}
                alt={featuredEvent.title}
                className="w-full h-64 md:h-full object-cover object-top"
              />
            </div>
            <div className="md:w-1/2 p-8">
              <div className="flex items-center mb-4">
                <span className="bg-red-100 text-red-800 text-sm font-medium px-3 py-1 rounded-full">
                  {featuredEvent.category}
                </span>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                {featuredEvent.title}
              </h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-center text-gray-600">
                  <i className="ri-calendar-line text-red-600 mr-3"></i>
                  <span>{featuredEvent.date}</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <i className="ri-time-line text-red-600 mr-3"></i>
                  <span>{featuredEvent.time}</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <i className="ri-map-pin-line text-red-600 mr-3"></i>
                  <span>{featuredEvent.location}</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <i className="ri-ticket-line text-red-600 mr-3"></i>
                  <span>{featuredEvent.price}</span>
                </div>
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed">
                {featuredEvent.description}
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button className="flex-1">
                  Register Now
                </Button>
                <Link to="/events" className="flex-1">
                  <Button variant="outline" className="w-full">
                    View All Events
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};
